import { render, staticRenderFns } from "./Restore.vue?vue&type=template&id=05cfe942&scoped=true&"
import script from "./Restore.vue?vue&type=script&lang=ts&"
export * from "./Restore.vue?vue&type=script&lang=ts&"
import style0 from "./Restore.vue?vue&type=style&index=0&id=05cfe942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cfe942",
  null
  
)

export default component.exports